<ng-container *ngIf="state.areTagsVisible">
  <div class="tag" *ngFor="let tag of state.tags; trackBy: trackByValue">
    <span>{{ tag }}</span>
    <button
      *ngIf="state.editable"
      mat-icon-button
      class="tag-remove really-small-icon-button"
      (click)="remove(tag)"
      y42StopPropagation
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <button
    *ngIf="state.editable"
    mat-icon-button
    class="small-icon-button"
    [matMenuTriggerFor]="menu"
    y42StopPropagation
  >
    <y42-icon [icon]="plusIcon"></y42-icon>
  </button>
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent>
      <y42-filterable-items-list
        listMode="list"
        [items]="state.featureTypeTags"
        [enableCreateItemButton]="true"
        searchPlaceholder="Search for tags"
        createItemButtonLabel="Create new tag"
        emptyListLabel="No tags available"
        (createItem)="add($event)"
        (selectionChange)="onSelectItems($event)"
      >
        <span *y42FilterableListItem="state.featureTypeTags; let tag">{{ tag }}</span>
        <span *y42FilterableListSummaryItem="let tag">{{ tag }}</span>
      </y42-filterable-items-list>
    </ng-template>
  </mat-menu>
</ng-container>
